<div class="flex flex-col px-4 pt-2 gap-2" *ngIf="isDataLoaded">
    <div class="flex flex-row">
      <div class="w-1/3"> {{ appConstants.dateRange }}</div>
      <thera-dropdown
        class="w-2/3"
        [options]="dateRange"
        (optionSelected)="onDateValueUpdate($event)"
        [defaultSelection]="dateRangeSelection"
      ></thera-dropdown>
    </div>
    <div *ngIf="displayFilters?.isDisciplineFilter" class="flex flex-row">
      <div class="w-1/3"> {{ appConstants.discipline }} </div>
      <thera-dropdown
        class="w-2/3"
        [displayAllOptionForMultiSelect]="true"
        [multiple]="true"
        [options]="disciplines"
        [defaultSelection]="selectedDisciplines"
        (dropdownClosed)="onDisciplineChange()"
        (optionSelected)="onValueChange($event, alertFiltersEnum.Discipline)"
      ></thera-dropdown>
    </div>
    <div *ngIf="displayFilters?.isPatientFilter" class="flex flex-row">
      <div class="w-1/3"> {{ appConstants.patient }} </div>
      <thera-dropdown
        class="w-2/3"
        [autoSelectByDefault]="isAutoSelectByDefault(patients, selectedPatients)"
        [multiple]="true"
        [options]="patients"
        [displayAllOptionForMultiSelect]="true"
        [defaultSelection]="isMultiSelect(patients) ? selectedPatients : null"
        (optionSelected)="onValueChange($event, alertFiltersEnum.Patient)"
      ></thera-dropdown>
    </div>
    <div *ngIf="displayFilters?.isTherapistFilter" class="flex flex-row">
      <div class="w-1/3"> {{ appConstants.therapist }} </div>
      <thera-dropdown
        class="w-2/3"
        [autoSelectByDefault]="isAutoSelectByDefault(displayTherapists, selectedTherapists)"
        [multiple]="true"
        [options]="displayTherapists"
        [displayAllOptionForMultiSelect]="true"
        [defaultSelection]="isMultiSelect(displayTherapists) ? selectedTherapists : null"
        (optionSelected)="onValueChange($event, alertFiltersEnum.Therapist)"
      ></thera-dropdown>
    </div>
    <div *ngIf="displayFilters?.isPhysicianFilter" class="flex flex-row">
      <div class="w-1/3"> {{ appConstants.physician }} </div>
      <thera-dropdown
        class="w-2/3"
        [autoSelectByDefault]="isAutoSelectByDefault(physicians, selectedPhysicians)"
        [multiple]="true"
        [options]="physicians"
        [displayAllOptionForMultiSelect]="true"
        [defaultSelection]="isMultiSelect(physicians) ? selectedPhysicians : null"
        (optionSelected)="onValueChange($event, alertFiltersEnum.Physician)"
      ></thera-dropdown>
    </div>
    <div class="flex flex-row items-end justify-end">
      <thera-button
        class="ml-2"
        [config]="{ variant: buttonVariant.SECONDARY, text: 'Apply' }"
        (click)="applyFilter()"
      ></thera-button>
    </div>
  </div>